import React, { useContext, useState } from "react";
import moment from "moment";
import Select from "react-select";
import { Row, Card, CardBody, Col, Table, Modal, ModalBody } from "reactstrap";
import "flatpickr/dist/themes/material_blue.css";
import Flatpickr from "react-flatpickr";
import { AttendanceContext } from "../../../context/attendanceContext";
import ReactHTMLTableToExcel from "react-html-table-to-excel";
import Loading from "../../Loader/Loader";
import Swal from "sweetalert2";
import { useDispatch, useSelector } from "react-redux";
import { getAttendanceReport } from "../../../actions/school_user/Attenadance";
import Loader from "../../Loader/Loader";
import { useEffect } from "react";
const LeftSidebar = ({
  handlePresentClick,
  AttendanceReport,
  Ptoggle,
  presentmodal,
  selectedYear,
  setSelectedYear,
  setSelectedMonth,
  selectedMonth,
}) => {
  const [isNotMobile, setIsNotMobile] = useState(window.innerWidth > 768);

  useEffect(() => {
    setIsNotMobile(window.innerWidth > 768);
  }, [window.innerWidth]);
  const token = localStorage.getItem("token");

  const {
    classListOption,
    handleclassselect,
    selectedDate,
    handleDateChange,
    classSelect,
    school_id,
    session_id,
    isLoading,
    setIsLoading,
  } = useContext(AttendanceContext);

  const { studentreport } = useSelector((state) => state.attendance);
  let d = new Date(selectedDate);

  console.error(
    d,
    "_________________________________selectedDate _ _________________________________"
  );
  const [month, setMonth] = useState("");
  const [year, setYear] = useState("");
  const dispatch = useDispatch();

  const String = (str) => {
    let num = str;
    num = str.toString();
    return num;
  };

  const fileName = () => {
    const date = new Date(selectedDate);
    const monthNames = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];
    const month = monthNames[date.getMonth()];
    const year = date.getFullYear();
    let name = "Attendance Report";
    return name;
  };

  const currentMonth = String(new Date().getMonth() + 1).padStart(2, "0");

  const months = [
    { value: "01", label: "January" },
    { value: "02", label: "February" },
    { value: "03", label: "March" },
    { value: "04", label: "April" },
    { value: "05", label: "May" },
    { value: "06", label: "June" },
    { value: "07", label: "July" },
    { value: "08", label: "August" },
    { value: "09", label: "September" },
    { value: "10", label: "October" },
    { value: "11", label: "November" },
    { value: "12", label: "December" },
  ];

  const currentYear = new Date().getFullYear();

  const getDaysInMonth = (month, year) => {
    const lastDay = new Date(year, month, 0).getDate();
    const days = [];
    for (let day = 1; day <= lastDay; day++) {
      // Format the date as dd/mm/yyyy
      const formattedDate = `${day.toString().padStart(2, "0")}/${month
        .toString()
        .padStart(2, "0")}/${year}`;
      days.push(formattedDate);
    }
    return days;
  };

  const daysInSelectedMonth = getDaysInMonth(selectedMonth, selectedYear);

  const handleMonthChange = (event) => {
    console.log(event.target.value, "value for Month ");
    setSelectedMonth(event.target.value);
    setMonth(event.target.value);
  };

  const years = () => {
    const currentYear = new Date(selectedDate).getFullYear();
    const yearsArray = [];
    for (let i = currentYear - 0; i <= currentYear + 0; i++) {
      yearsArray.push(i.toString());
    }
    return yearsArray[0];
  };

  const handleYearChange = (value) => {
    console.log(value, "value");
    if (value.length <= 4) {
      setSelectedYear(value);
      setYear(value);
    }
  };
  // const handlePresentClick = (arg) => {
  //   console.log("i am click");
  //   GenerateAttendanceReport();
  // };

  return (
    <>
      <Card>
        <CardBody className="p-3 ">
          <Row className="mb-0">
            <div className="col-sm-12">
              <h4 className="card-title mb-2  text-start">Select Class</h4>
              <Select
                name="class_id"
                placeholder="Select Class..."
                options={classListOption}
                value={
                  classSelect
                    ? classListOption?.find((c) => c.value === classSelect)
                    : null
                }
                onChange={handleclassselect}
                isSearchable={true}
              />
            </div>
          </Row>
        </CardBody>
      </Card>
      <Card className="order-1">
        <CardBody className="p-3">
          <div className="form-group mb-0">
            <h4 className="card-title mb-2  text-start">Select Date123456</h4>
            <Flatpickr
              className="form-control d-block"
              placeholder="dd M,yyyy"
              value={d}
              onChange={handleDateChange}
              options={{
                inline: true,
                dateFormat: "d M Y",
                maxDate: new Date(),
                // altInput: true,
                // altFormat: "F j, Y",
                // dateFormat: "Y-m-d",
              }}
            />
          </div>
        </CardBody>
      </Card>
      {isNotMobile && (
        <Card>
          <CardBody className="p-4">
            <div className="text-center">
              <Row className="">
                <Col xl={12}>
                  <h4 className="card-title mb-3 me-2 text-start">
                    Generate Attendance Report
                  </h4>
                  <Row>
                    <Col>
                      <h4 className="card-title me-4 text-start">Month</h4>
                      <select
                        value={selectedMonth}
                        className="form-control"
                        onChange={handleMonthChange}
                      >
                        <option
                          value=""
                          disabled
                          style={{ fontWeight: "bold" }}
                        >
                          Select Month
                        </option>
                        {months.map((month) => (
                          <option
                            key={month.value}
                            value={month.value}
                            className="text-dark"
                          >
                            {month.label}
                          </option>
                        ))}
                      </select>
                    </Col>
                    <Col>
                      <h4 className="card-title me-4 text-start">Year</h4>
                      <input
                        className="form-control"
                        value={selectedYear}
                        onChange={(e) => handleYearChange(e.target.value)}
                        type="number"
                      />
                    </Col>
                  </Row>

                  <button
                    onClick={() => handlePresentClick()}
                    type="button"
                    className="btn bg-primary text-white btn-rounded text-center mt-4"
                  >
                    GENERATE {fileName().toUpperCase()}
                  </button>

                  <Modal
                    isOpen={presentmodal}
                    toggle={Ptoggle}
                    // style={{ width: "380px" }}
                    size="xl"
                  >
                    <ReactHTMLTableToExcel
                      id="test-table-xls-button"
                      className="download-table-xls-button btn-lg btn btn-success"
                      color="success"
                      table="table-to-xls"
                      filename={fileName()}
                      sheet="tablexls"
                      buttonText="Print"
                    />
                    <ModalBody>
                      <Card className="shadow-none">
                        <CardBody>
                          <div className="table-responsive">
                            <Table
                              className="table table-striped"
                              id="table-to-xls"
                            >
                              <thead>
                                <tr>
                                  <th className="text-center">Sr.</th>
                                  <th className="text-center"  style={{ whiteSpace: "nowrap" }}>Roll No</th>
                                  <th className="text-center">Name</th>
                                  {daysInSelectedMonth.map((date, index) => (
                                    <th
                                      className="text-center"
                                      key={index}
                                      style={{ whiteSpace: "nowrap" }}
                                    >
                                      {date}
                                    </th>
                                  ))}
                                  <th className="text-center">Present</th>
                                  <th className="text-center">Absent</th>
                                </tr>
                              </thead>
                              <tbody>
                                {AttendanceReport?.map((stu, index) => (
                                  <tr key={index}>
                                    <th scope="row" className="text-center">
                                      {index + 1}
                                    </th>
                                    <td className="text-center" >
                                      {stu.student_roll_no}
                                    </td>
                                    <td className="text-center">
                                      {stu.student_name}
                                    </td>

                                    {/* Loop through the attendance data for each day */}
                                    {daysInSelectedMonth.map((_, dayIndex) => (
                                      <td
                                        key={dayIndex}
                                        className="text-center"
                                      >
                                        {stu[dayIndex + 1]}{" "}
                                        {/* Assuming the attendance data for each day starts from index 1 */}
                                      </td>
                                    ))}

                                    <td className="text-center">
                                      {stu.present}
                                    </td>
                                    <td className="text-center">
                                      {stu.absent}
                                    </td>
                                  </tr>
                                ))}
                              </tbody>
                            </Table>
                          </div>
                        </CardBody>
                      </Card>
                    </ModalBody>
                  </Modal>
                </Col>
              </Row>
            </div>
          </CardBody>
        </Card>
      )}
    </>
  );
};

export default LeftSidebar;
